import AvancedReport from 'src/views/Pages/Dashboard/Disease/AvancedReport/AvancedReport.vue';
import CasesConfirmation from 'src/views/Pages/Dashboard/Disease/CasesConfirmation/CasesConfirmation.vue';
import ConfirmationReport from 'src/views/Pages/Dashboard/Disease/ConfirmationReport/ConfirmationReport.vue';
import Diseases from 'src/views/Pages/Dashboard/Disease/Diseases.vue';
import DiseasesCreateEdit from 'src/views/Pages/Dashboard/Disease/DiseasesCreateEdit.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';
import PathMap from 'src/views/Pages/Dashboard/Disease/PathMap/PathMap.vue';
import PerimeterConditionRoutes from 'src/views/Pages/Dashboard/PerimeterCondition/perimeter-conditions-routes';
import PerimeterStatus from 'src/views/Pages/Dashboard/Disease/PerimeterStatus/PerimeterStatus.vue';
import Reports from 'src/views/Pages/Dashboard/Disease/Report/Reports.vue';

const DiseasesRoutes = {
    path: 'diseases',
    component: MasterTab,
    props: { reference: 'diseaseTabs' },
    children: [
        {
            path: 'diseases',
            component: EmptyRouterView,
            children: [
                {
                    path: '',
                    name: 'diseases.diseases_and_plagues',
                    component: Diseases,
                    meta: {
                        prefix_permission: 'diseases_diseases',
                    },
                },
                {
                    path: 'create',
                    name: 'diseases.diseases_and_plagues',
                    component: DiseasesCreateEdit,
                    meta: {
                        prefix_permission: 'diseases_diseases',
                    },
                },
                {
                    path: 'edit',
                    name: 'diseases.diseases_and_plagues',
                    component: DiseasesCreateEdit,
                    meta: {
                        prefix_permission: 'diseases_diseases',
                    },
                },
            ],
        },
        {
          path: 'diseasesamples',
           name: 'diseases.diseases_and_plagues',
           component: Reports,
           meta: {
             prefix_permission: 'diseases_diseasesamples',
           },
        },
        {
            path: 'advancedreport',
            name: 'diseases.advanced_report',
            component: AvancedReport,
            meta: {
                prefix_permission: 'diseases_advancedreport',
            },
        },
        {
            path: 'pathmap',
            name: 'diseases.pathmap',
            component: PathMap,
            meta: {
                prefix_permission: 'diseases_pathmap',
            },
        },
        {
            path: 'casesconfirmation',
            name: 'diseases.results_report',
            component: CasesConfirmation,
            meta: {
                prefix_permission: 'diseases_casesconfirmation',
            },
        },
        {
            path: 'casesconfirmationreport',
            name: 'diseases.lab_results',
            component: ConfirmationReport,
            meta: {
                prefix_permission: 'diseases_casesconfirmationreport',
            },
        },
        {
            path: 'perimeterstatus',
            name: 'diseases.perimeter_status',
            component: PerimeterStatus,
            meta: {
                prefix_permission: 'diseases_perimeterstatus',
            },
        },
        PerimeterConditionRoutes,
    ],
};

export default DiseasesRoutes;